import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';
import AccessDeniedPage from '../../shared/components/AccessDeniedPage';
import { getRole, isLoggedIn } from '../redux/auth.redux';
import { routes } from '../../routes';


@withRouter
@connect(
  state => ({
    authorized: isLoggedIn(state),
    userRole: getRole(state),
  }), null, null, { pure: false },
)
class ProtectedRoute extends Component {
  static propTypes = {
    authorized: PropTypes.bool,
    cmp: PropTypes.func.isRequired,
    roleAccess: PropTypes.string,
    userRole: PropTypes.string,
  };

  static defaultProps = {
    roleAccess: '',
    userRole: '',
    authorized: true,
  };

  renderRoute = (...args) => {
    const {
      authorized,
      cmp: AuthorizedComponent,
      roleAccess,
      userRole,
    } = this.props;

    if (authorized && !!roleAccess && roleAccess !== userRole) {
      return (<AccessDeniedPage />);
    }

    return authorized
      ? <AuthorizedComponent {...args} />
      : <Redirect to={routes.login} />;
  };

  render() {
    const { ...rest } = this.props;
    return <Route {...rest} render={this.renderRoute} />;
  }
}

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/Auth/components/ProtectedRoute.js